/**
 * Extract a column of data with specified field.
 */
export const Field = ({ value }) => {
    return (data) => data.map((d) => d[value]);
};
Field.props = {};
//# sourceMappingURL=field.js.map